import React from 'react';
import EpsHeroCard from '@/components/ui/EpsHeroCard';
import CategoryCard from '@/components/ui/CategoryCard';
import type { ExplosiveProfile } from '@/lib/scoring';

interface AthleteProfile {
  id: string;
  name: string;
  age?: number;
  sport?: string;
  position?: string;
  heightIn?: number;
  weightLbs?: number;
  trainingAge?: number;
  injuryHistory?: string;
  seasonPhase?: string;
  avatarInitials?: string;
}

interface TestSession {
  id: string;
  date: string;
  eps: number;
  engineScore: number;
  ignitionScore: number;
  bounceScore: number;
}

interface ProfileHeroProps {
  profile: ExplosiveProfile;
  athlete: AthleteProfile;
  session: TestSession;
}

export default function ProfileHero({ profile, athlete, session }: ProfileHeroProps) {
  const date = new Date(session.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <EpsHeroCard
        eps={profile.eps}
        athleteName={athlete.name}
        sessionDate={date}
        primaryPriority={profile.primaryPriority}
      />
      <CategoryCard category="Engine" score={profile.engineScore} />
      <CategoryCard category="Ignition" score={profile.ignitionScore} />
      <CategoryCard category="Bounce" score={profile.bounceScore} />
    </div>
  );
}